export class HistoryNames {
    static FILTER = {name: 'Applied: filter', icon: 'filter-custom'};
    static RESIZE = {name: 'Applied: resize', icon: 'resize-custom'};
    static CROP = {name: 'Applied: crop', icon: 'crop-custom'};
    static TRANSFORM = {name: 'Applied: transform', icon: 'transform-custom'};
    static DRAW = {name: 'Added: drawing', icon: 'pencil-custom'};
    static TEXT = {name: 'Added: text', icon: 'text-box-custom'};
    static SHAPES = {name: 'Added: shape', icon: 'polygon-custom'};
    static STICKERS = {name: 'Added: sticker', icon: 'sticker-custom'};
    static FRAME = {name: 'Added: frame', icon: 'frame-custom'};
    static MERGE = {name: 'Objects: merged', icon: 'merge-custom'};
    static CORNERS = {name: 'Applied: rounded corners', icon: 'rounded-corners-custom'};
    static BACKGROUND = {name: 'Changed: background', icon: 'background-custom'};
    static BG_IMAGE = {name: 'Changed: background Image', icon: 'photo-library'};
    static OVERLAY_IMAGE = {name: 'Added: overlay Image', icon: 'photo-library'};
    static INITIAL = {name: 'Initial', icon: 'home'};
    static LOADED_STATE = {name: 'Loaded: state', icon: 'history'};
    static OBJECT_STYLE = {name: 'Changed: style', icon: 'color-custom'};
}
